export default "__VITE_ASSET__hdenKo0m__"